import React from 'react';
import classnames from 'classnames';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';

const ArrowLeft = ({ className, ...props }) => {
  return (
    <ArrowBackOutlinedIcon
      style={{
        cursor: 'pointer',
        fill: '#fff',
        width: '30px',
        height: '30px'
      }}
      className={classnames({
        icon: true,
        [className]: !!className
      })}
      {...props}
    />
  );
};

export default ArrowLeft;
